import React from 'react';
import './home-styles/home-section2.scss';
import gold_appraiser from '../../assets/images/gold_apprasier.jpg'
const HomeSection2 = () => {
  return (
    <div className='home-section2'>
      <div className='section light-section'>
        <div className='row justify-content-center'>
          <div className='col-12 d-flex justify-content-center align-items-center heading-section'>
            <h3 className='text-primary-color'>ABOUT GOLD APPRAISER</h3>
          </div>
          <div className='row about-container'>
  {/* Image Section */}
  <div className='col-12 col-md-4 mb-4 mb-md-0'>
    <div className='text-center d-flex flex-column align-items-center'>
      <img src={gold_appraiser} alt="round" className="round-image" />
    </div>
  </div>

  {/* Text Section */}
  <div className='col-12 col-md-8 d-flex align-items-center about-appraiser'>
    <p style={{color:'black'}}>
      A Gold Appraiser is a skilled professional who assesses the purity, weight, 
      and value of gold using specialized tools and techniques. 
      They ensure the authenticity and quality of gold before it is sold, bought, or used for loans.
    </p>
  </div>
</div>

        </div>
      </div>
    </div>
  );
};

export default HomeSection2;
